import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import './styles.scss';
import Icons from 'core/data/constants/Icons';
import Images from 'core/data/constants/Images';
import CustomDrawer from 'core/components/CustomDrawer';

export const NavBar = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        // Smooth scroll
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <nav className="navBar">
      <div>
        <div className='drawer'>
          <CustomDrawer></CustomDrawer>
        </div>
        <a href="/" className="logo-section">
          <img src={Images.LogoImage} alt="t(ironing_sara')" />
        </a>
        <div className="phoneNumber">
          {Icons.Phone()}
          <p>{t('default_phone_number')}</p>
        </div>
      </div>
      <ul className={'navBarLinks navigationListNavBar'}>
        <li>
          <Link to="/">{t('default_home')}</Link>
          <div className="dropdown">
            <Link to="/ironing">
              {t('default_ironing')}
              <span>{Icons.ArrowHead()}</span>
            </Link>
            <div className="dropdown-box">
              <Link to="/ironing#washingIroningDryClean" className="dropdown-item">
                {t('washing_ironing_dry_clean')}
              </Link>

              <Link to="/ironing#ironingPackagesTableSection" className="dropdown-item">
                {t('ironing_package')}
              </Link>

              <Link to="/ironing#ironingTableSection" className="dropdown-item">
                {t('ironing')}
              </Link>

            </div>
          </div>
          <Link to="/sewing">{t('default_sewing')}</Link>
          <Link to="/dryCleaning">{t("dry_cleaning")}</Link>
          <Link to="/#contactUs">{t('default_contacts')}</Link>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
